import type { FC, MouseEvent, Ref, RefObject, MutableRefObject } from 'react';
import { observer } from 'mobx-react';
import { Picture } from '@ui';
import { inputCross } from '@images';
import type { storeAddressT } from '@store/UserStore.type';
import OrderRegisterCustomMap from '@components/OrderRegistration/components/OrderRegisterCustomMap';
import ChooseAddressPickupsMobileList from '../ChooseAddressPickupsMobileList';
import ModalHeader from '../components/ModalHeader';
import ModalButtonBar from '../components/ModalButtonBar';
import MapToggle from '../components/MapToggle';

interface AddressListStageProps {
  isMobile: boolean;
  isOpenMap: boolean;
  setIsOpenMap: (v: boolean) => void;
  selectedAddress: number | null;
  elRefs: Array<RefObject<HTMLDivElement>>;
  mobileListStyle: { height: string };
  mapRef: ((instance: Ref<any>) => void) | MutableRefObject<any> | undefined;
  coords: number[];
  editAddress: boolean;
  iconContentTemplate: any;
  onMapClick: (e: any, mapRefName: string) => void;
  onLoadMap: (ymaps: any) => void;
  isDefaultMark: () => boolean;
  selectAddress: (item: storeAddressT) => void;
  changeStateModalEdit: (
    item: storeAddressT,
    e: MouseEvent<HTMLImageElement>
  ) => void;
  deleteAddress: (e: MouseEvent<HTMLImageElement>, item: storeAddressT) => void;
  onAddNewAddress: () => void;
  onConfirm: () => void;
  onClose: () => void;
}

const AddressListStage: FC<AddressListStageProps> = observer(
  ({
    isMobile,
    isOpenMap,
    setIsOpenMap,
    selectedAddress,
    elRefs,
    mobileListStyle,
    mapRef,
    coords,
    editAddress,
    iconContentTemplate,
    onMapClick,
    onLoadMap,
    isDefaultMark,
    selectAddress,
    changeStateModalEdit,
    deleteAddress,
    onAddNewAddress,
    onConfirm,
    onClose
  }) => {
    if (isMobile) {
      return (
        <div className='left'>
          <ModalHeader
            title='Адреса доставки'
            right={
              <Picture icon={inputCross} height='20' alt='' onClick={onClose} />
            }
          />

          <MapToggle isOpenMap={isOpenMap} onChange={setIsOpenMap} />

          {isOpenMap ? (
            <OrderRegisterCustomMap
              mapRef={mapRef}
              onMapClick={onMapClick}
              onLoadMap={onLoadMap}
              coords={coords}
              editAddress={editAddress}
              iconContentTemplate={iconContentTemplate}
              isShowMapMarkPlace={false}
              isDefaultMark={isDefaultMark}
              selectedAddress={selectedAddress}
              selectAddress={selectAddress}
              width='100%'
              height={mobileListStyle.height}
              mapRefName='mapRefModal'
              isShowClusterer
            />
          ) : (
            <ChooseAddressPickupsMobileList
              selectedAddress={selectedAddress}
              elRefs={elRefs}
              style={mobileListStyle}
              changeStateModalEdit={changeStateModalEdit}
              deleteAddress={deleteAddress}
              selectAddress={selectAddress}
            />
          )}

          <ModalButtonBar
            hideCancel={isOpenMap}
            cancelLabel='Добавить новый адрес'
            onCancel={onAddNewAddress}
            confirmLabel='Привезти сюда'
            onConfirm={onConfirm}
          />

          <div className='btns'>
            <span className='title' />
            <span className='city' />
          </div>
        </div>
      );
    }

    return (
      <div className='left'>
        <ModalHeader
          title='Мои адреса'
          right={null}
          // right={
          //   <>
          //     <Picture icon={navigationCreateOrder} height='20' alt='' />
          //     {cartStore.regionData?.title || 'Москва'}
          //   </>
          // }
        />
        <ChooseAddressPickupsMobileList
          changeStateModalEdit={changeStateModalEdit}
          elRefs={elRefs}
          deleteAddress={deleteAddress}
          selectAddress={selectAddress}
          selectedAddress={selectedAddress}
        />
        <ModalButtonBar
          cancelLabel='Добавить новый адрес'
          onCancel={onAddNewAddress}
          confirmLabel='Выбрать этот адрес'
          onConfirm={onConfirm}
        />

        <div className='btns'>
          <span className='title' />
          <span className='city' />
        </div>
      </div>
    );
  }
);

export default AddressListStage;
